<template>
  <validation-form @on-submit="saveViaEmail">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h1 class="text-base color-[#242424] pb-4">
          {{ $t("survey.mail_content") }}
        </h1>
      </div>
      <div class="md-layout-item md-size-33">
        <validation-field :validations="{ required: true }" name="subject">
          <label>{{ $t("common.subject") }}</label>
          <md-input required v-model="content.subject"> </md-input>
        </validation-field>
      </div>
      <div class="md-layout-item md-size-100">
        <label>{{ $t("survey.body") }}</label
        ><span class="text-red-600"> *</span>
        <div class="border border-gray-300 p-2 relative">
          <validation-field
            :validations="{ required: true }"
            name="body"
            isTextArea="true"
          >
            <md-textarea class="p-0" v-model="content.body"></md-textarea>
          </validation-field>
        </div>
      </div>
      <div class="md-layout-item md-size-100 md-layout my-4 pt-2">
        <div class="md-layout-item md-size-50 pl-0 font-semibold">
          {{ name }} = {{ $t("survey.respondent_full_name") }}
        </div>
        <div class="md-layout-item md-size-50 font-semibold">
          {{ url }} = {{ $t("survey.user_survey_link") }}
        </div>
      </div>
      <div class="md-layout-item md-size-100 flex justify-end gap-4 mt-5">
        <md-button class="md-raised" @click="cancel">
          {{ $t("common.cancel") }}
        </md-button>
        <md-button class="md-success" type="submit">
          {{ $t("survey.send_via_mail") }}
        </md-button>
      </div>
    </div>
  </validation-form>
</template>

<script>
import { Message } from "@/helpers/utils";
import { service_names } from "@/constants/Services";

export default {
  props: ["dataMail", "surveyId"],
  data() {
    return {
      name: "${full_name}",
      url: "${survey_url}",
      content: {
        subject: "",
        body: null
      }
    };
  },
  created() {
    if (this.dataMail) {
      this.content = this.dataMail.email_content;
    }
  },
  methods: {
    cancel() {
      this.$emit("hideModalSendMail");
    },
    saveViaEmail() {
      this.dataMail.email_content = this.content;
      this.$axios
        .put(`${service_names.school}/survey/${this.surveyId}`, this.dataMail)
        .then(() => {
          Message.success(this.$t("common.send_mail_success"));
          this.$emit("hideModalSendMail");
          this.$emit("reFetchTableData");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  min-height: 80px;
  padding: 0 16px;
  resize: none;
}
</style>
